import React, { useState } from "react";
import { Box, Grid, IconButton } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos, Close } from "@material-ui/icons";

const MediaGallery = ({ galleryImages }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openFullscreen = (index) => {
    setCurrentIndex(index);
    setIsFullscreen(true);
  };

  const closeFullscreen = () => {
    setIsFullscreen(false);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };

  return (
    <div style={{ padding: "16px" }}>
      <Grid container spacing={2}>
        {galleryImages.map((item, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={index}
            style={{ cursor: "pointer" }}
            onClick={() => openFullscreen(index)}
          >
            {item.type === "video" ? (
              <div
                style={{
                  position: "relative",
                  overflow: "hidden",
                  height: "200px",
                  borderRadius: "8px",
                }}
              >
                <video
                  src={item.src}
                  className="gallery-video"
                  controls
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  position: "relative",
                  overflow: "hidden",
                  height: "200px",
                  borderRadius: "8px",
                }}
              >
                <img
                  src={item.src}
                  alt={`Media ${index}`}
                  className="gallery-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
          </Grid>
        ))}
      </Grid>

      {/* Fullscreen View */}
      {isFullscreen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0, 0, 0, 0.9)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Media Content */}
          {galleryImages[currentIndex]?.type === "video" ? (
            <video
              src={galleryImages[currentIndex]?.src}
              controls
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "8px",
              }}
            />
          ) : (
            <img
              src={galleryImages[currentIndex]?.src}
              alt={`Media ${currentIndex}`}
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          )}

          {/* Close Button */}
          <IconButton
            onClick={closeFullscreen}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "10px",
            }}
          >
            <Close />
          </IconButton>

          {/* Previous Button */}
          <IconButton
            onClick={handlePrevious}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "10px",
            }}
          >
            <ArrowBackIos />
          </IconButton>

          {/* Next Button */}
          <IconButton
            onClick={handleNext}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "10px",
            }}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      )}
    </div>
  );
};

export default MediaGallery;
